export const INITIAL_STATE = {
    id: null,
    text: null,
    type: null,
    isVisible: false,
    actions: [],
};
